import { render } from "./Pagelist.vue?vue&type=template&id=6da56166&scoped=true"
import script from "./Pagelist.vue?vue&type=script&lang=js"
export * from "./Pagelist.vue?vue&type=script&lang=js"

import "./Pagelist.vue?vue&type=style&index=0&id=6da56166&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da56166"]])

export default __exports__